<template>
  <v-form ref="form" style="border: solid 1px lightgray; border-radius: 4px;" class="pa-3">
    <v-simple-table class>
      <template v-slot:default>
        <tbody>
          <tr>
            <td class="text-left">Tổng Tiền:</td>
            <td class="text-right">{{sum | formatMoney}}</td>
          </tr>
          <tr>
            <td class="text-left">Giảm Giá:</td>
            <td class="text-right">
              <currency-input dense v-model="discount"></currency-input>
            </td>
          </tr>
          <tr>
            <td class="text-left nowrap">Học viên Cần Trả:</td>
            <td
              class="text-right body-1 font-weight-black green--text nowrap"
            >{{total | formatMoney}}</td>
          </tr>
          <tr>
            <td class="text-left">Học viên Thanh Toán:</td>
            <td class="text-right">
              <currency-input dense v-model="paid"></currency-input>
            </td>
          </tr>
          <tr>
            <td class="text-left nowrap">Học viên Nợ:</td>
            <td
              class="text-right body-1 font-weight-black red--text nowrap"
            >{{liabilities | formatMoney}}</td>
          </tr>
          <tr>
            <td class="text-left nowrap">Thanh Toán:</td>
            <td class="text-right body-1 nowrap">
              <v-select
                v-model="paymentType"
                :items="paymentTypes"
                dense
                item-text="title"
                item-value="status"
              ></v-select>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <autocomplete-student
      v-model="student"
      placeholder="Tìm kiếm học sinh"
      label="Học Sinh"
      dense
      return-object
      @change="selectStudent"
    />
    <v-text-field v-model="customerName" label="Người Nộp Tiền" dense></v-text-field>
    <v-text-field v-model="customerPhone" label="SDT Người Nộp Tiền" dense></v-text-field>
    <date-picker :date.sync="date" label="Ngày" placeholder="Nhập Ngày" dense></date-picker>
    <v-textarea full-width no-resize placeholder="Ghi chú" v-model="notes" dense :height="50"></v-textarea>
    <div class="text-center">
      <v-btn color="primary" x-large class="elevation-0" @click="save()">
        <v-icon left dark>mdi-domain</v-icon>Lưu Lại
      </v-btn>
    </div>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import CurrencyInput from '@/components/basic/input/CurrencyInput.vue'
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import DatePicker from '@/components/basic/picker/DateIOSPicker.vue'
import _ from 'lodash'
import utils from '@/plugins/utils.js'
export default {
  components: { CurrencyInput, AutocompleteStudent, DatePicker },
  props: {
    bill: Object,
    products: Array
  },
  data () {
    return {
      date: '',
      discount: '0',
      paid: '0',
      notes: '',
      student: null,
      customerName: '',
      customerPhone: '',
      paymentType: 'cash',
      loading: false
    }
  },
  created () {
    this.reset()
  },
  computed: {
    ...mapState('constant', ['billStatus', 'paymentTypes']),
    sum () {
      return this.products.reduce(
        (acc, cur) => (acc += cur.price * cur.quantity),
        0
      )
    },
    total () {
      return this.sum - parseInt(this.discount)
    },
    liabilities () {
      return this.total - parseInt(this.paid)
    }
  },
  methods: {
    selectStudent (student) {
      this.student = student
      this.customerName = student.name
      this.customerPhone = student.phone
      this.customerName = student.name
    },
    getValues () {
      return {
        id: this.bill.id,
        notes: this.notes,
        status: this.liabilities > 0 ? 'liabilities' : 'paid',
        liabilities: this.liabilities,
        total: this.total,
        items: this.products,
        discount: parseInt(this.discount),
        sum: parseInt(this.sum),
        student: _.get(this.student, 'id'),
        contact: _.get(this.contact, 'id'),
        paymentType: this.paymentType,
        customerPaid: parseInt(this.paid) || 0,
        provider: this.provider ? this.provider : 'direct-sale',
        customerName: this.customerName,
        customerPhone: this.customerPhone
      }
    },
    save () {
      this.$emit('save', this.getValues())
    },
    reset () {
      this.customerName = this.bill.customerName
      this.customerPhone = this.bill.customerPhone
      this.notes = this.bill.notes
      this.discount = this.bill.discount
      this.date = this.bill.date
      this.student = this.bill.student
      this.staff = this.bill.staff
      this.contact = this.bill.contact
      this.customerPaid = this.bill.customerPaid
      this.paymentType = this.bill.paymentType
      this.provider = this.bill.provider
    }
  },
  filters: {
    formatMoney (amount) {
      return utils.formatMoney(amount)
    }
  },
  watch: {
    total (total) {
      this.paid = this.total
    },
    bill (bill) {
      this.reset()
    }
  }
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
}
td {
  padding-left: 0 !important;
}
</style>
